import React from 'react';
import FirebaseAuth from 'react-firebaseui/FirebaseAuth';
import withFormContainer from './withFormContainer.jsx';
import Divider from './Divider.jsx';

import { defaultApp } from '../utils/firebase';

import './UserLoginForm.css';

const MODE_SIGN_IN = 'sign-in';
const MODE_SIGN_UP = 'sign-up';
const MODE_FORGOT_PASSWORD = 'forgot-password';

class UserLoginForm extends React.Component {

    firstField = React.createRef();

    state = {
        email: '',
        displayName: '',
        password: '',
        emailMode: '',
        message: '',
        allowed: true

    };

    componentDidUpdate(prevProps) {

        if (prevProps.isLoggedIn === false && this.props.isLoggedIn === true) {
            this.props.changeLoading(true);
        }
        if (prevProps.emailError === false && this.props.emailError === true) {
            this.setState({ message: 'An email address is required.' });
        }

        this.props.sendResizeEvent();
    }

    onChangeAllowed = e => {

        this.setState({ allowed: !this.state.allowed });
    };

    onChangeEmail = ({ currentTarget: { value: email } }) => {

        this.setState({ email, message: '' });
    };

    onChangeDisplayName = ({ currentTarget: { value: displayName } }) => {

        this.setState({ displayName, message: '' });
    };

    onChangePassword = ({ currentTarget: { value: password } }) => {

        this.setState({ password, message: '' });
    };

    onSetEmailMode = ({ currentTarget: { value: emailMode } }) => {

        this.setState({ emailMode, message: '' }, () => {

            if (emailMode) {
                this.firstField.current.blur();
            }
        });
    };

    onChangeRemember = ({ currentTarget: { checked } }) => {

        this.props.changeRemember(checked);
    };
    onChangeReAuth = ({ currentTarget: { checked } }) => {

        this.props.changeReAuth(checked);
    };

    onSignInUser = e => {

        e.preventDefault();

        this.props.changeLoading(true)
            .then(() => {

                const { email, password } = this.state;

                return defaultApp.auth().signInWithEmailAndPassword(email, password);
            })
            .catch(({ message }) => {

                this.setState({ message }, () => this.props.changeLoading(false));
            });
    };

    onSignUpUser = e => {

        e.preventDefault();

        this.props.changeLoading(true)
            .then(() => {

                const { email, password } = this.state;

                return defaultApp.auth().createUserWithEmailAndPassword(email, password);
            })
            .then(({ additionalUserInfo: { isNewUser }, user }) => {

                const { displayName } = this.state;

                return this.props.updateUserProfile(displayName).then(() => {

                    if (isNewUser && !user.emailVerified) {

                        return user.sendEmailVerification({
                            url: 'https://app.commentbox.io?redirect='+encodeURIComponent(this.props.url)
                        });
                    }
                });
            })
            .catch(({ message }) => {

                this.setState({ message }, () => this.props.changeLoading(false));
            });
    };

    onForgotPassword = e => {

        e.preventDefault();

        this.props.changeLoading(true)
            .then(() => {

                const { email } = this.state;

                return defaultApp.auth().sendPasswordResetEmail(email);
            })
            .then(() => {

                return this.props.changeLoading(false);
            })
            .catch(({ message }) => {

                this.setState({ message }, () => this.props.changeLoading(false));
            });
    };

    get firebaseAuth() {

        const style = {
            backgroundColor: this.props.ssoColor || '#000'
        };
        if (this.props.isLoggedIn) {
            style.display = 'none';
        }

        const ssoButton = this.props.sso ? (
            <button
                disabled={this.props.requestingUserPayload}
                style={style}
                onClick={this.props.onSingleSignOn}
                type="button"
                className="firebaseui-idp-button mdl-button mdl-js-button mdl-button--raised firebaseui-id-idp-button"
                data-provider-id="password" data-upgraded=",MaterialButton"
            >
                        <span className="firebaseui-idp-icon-wrapper">
                            <img className="firebaseui-idp-icon" alt="" src={this.props.ssoIcon} />
                        </span>
                <span className="firebaseui-idp-text firebaseui-idp-text-long">Sign in with {this.props.ssoText}</span>
            </button>
        ) : null;


        return (
            <div className="firebase-auth">
                {ssoButton}
                <FirebaseAuth
                    key={`reauth/${this.props.reAuth ? 'yes':'no'}/${this.props.emailError ? 'yes':'no'}`}
                    uiConfig={this.props.authUiConfig}
                    firebaseAuth={defaultApp.auth()}
                />
                <button
                    style={this.props.isLoggedIn ? { display: 'none' } : null}
                    onClick={this.onSetEmailMode}
                    value={MODE_SIGN_IN}
                    type="button"
                    className="firebaseui-idp-button mdl-button mdl-js-button mdl-button--raised firebaseui-idp-password firebaseui-id-idp-button"
                    data-provider-id="password" data-upgraded=",MaterialButton"
                >
                        <span className="firebaseui-idp-icon-wrapper">
                            <img className="firebaseui-idp-icon" alt="" src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/mail.svg"/>
                        </span>
                    <span className="firebaseui-idp-text firebaseui-idp-text-long">Sign in with email</span>
                    <span className="firebaseui-idp-text firebaseui-idp-text-short">Email</span>
                </button>
            </div>
        );
    }

    get signIn() {

        return (
            <form onSubmit={this.onSignInUser}>

                <p>
                    Sign in with an existing account. Don't have one? <button type="button" value={MODE_SIGN_UP} onClick={this.onSetEmailMode}>Sign up here.</button>
                </p>

                <div className="form-group">
                    <label htmlFor="email">
                        Email Address
                    </label>
                    <input
                        id="email"
                        type="email"
                        placeholder="jane@example.com"
                        value={this.state.email}
                        onChange={this.onChangeEmail}
                        ref={this.firstField}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="password">
                        Password
                    </label>
                    <input
                        id="password"
                        type="password"
                        placeholder="8 characters minimum"
                        value={this.state.password}
                        onChange={this.onChangePassword}
                        minLength={8}
                        autoComplete={this.props.reAuth ? 'off' : 'current-password'}
                        required
                    />
                </div>

                <div className="form-group">
                    <button
                        type="submit"
                        className="btn primary-button"
                        disabled={!this.state.email || this.state.password.length < 8}
                    >
                        Sign in
                    </button>
                    <button
                        type="button"
                        className="btn secondary-button"
                        onClick={this.onSetEmailMode}
                        value=""
                    >
                        Cancel
                    </button>
                    <button className="forgot" type="button" onClick={this.onSetEmailMode} value={MODE_FORGOT_PASSWORD}>
                        Forgot password?
                    </button>
                </div>

            </form>
        );
    }


    get signUp() {

        return (
            <form onSubmit={this.onSignUpUser}>

                <p>
                    Create a new account. Already have one? <button type="button" value={MODE_SIGN_IN} onClick={this.onSetEmailMode}>Sign in here.</button>
                </p>

                <div className="form-group">
                    <label htmlFor="email">
                        Email Address
                    </label>
                    <input
                        id="email"
                        type="email"
                        placeholder="jane@example.com"
                        value={this.state.email}
                        onChange={this.onChangeEmail}
                        autoComplete="off"
                        ref={this.firstField}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="display-name">
                        Full Name
                    </label>
                    <input
                        id="display-name"
                        type="text"
                        placeholder="Jane Doe"
                        value={this.state.displayName}
                        onChange={this.onChangeDisplayName}
                        autoComplete="off"
                        minLength={1}
                        maxLength={50}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="password">
                        Password
                    </label>
                    <input
                        id="password"
                        type="password"
                        placeholder="8 characters minimum"
                        value={this.state.password}
                        onChange={this.onChangePassword}
                        minLength={8}
                        autoComplete="off"
                        required
                    />
                </div>

                <div className="form-group">
                    <button
                        type="submit"
                        className="btn primary-button"
                        disabled={!this.state.email || !this.state.displayName || this.state.password.length < 8}

                    >
                        Sign up
                    </button>
                    <button
                        type="button"
                        className="btn secondary-button"
                        onClick={this.onSetEmailMode}
                        value=""
                    >
                        Cancel
                    </button>
                </div>

            </form>
        );
    }

    get forgotPassword() {


        return (
            <form onSubmit={this.onForgotPassword}>

                <p>
                    We'll email you a password reset link. Once you've reset it, <button type="button" value={MODE_SIGN_IN} onClick={this.onSetEmailMode}>enter it here.</button>
                </p>

                <div className="form-group">
                    <label htmlFor="email">
                        Email Address
                    </label>
                    <input
                        id="email"
                        type="email"
                        placeholder="jane@example.com"
                        value={this.state.email}
                        onChange={this.onChangeEmail}
                        autoComplete={this.props.reAuth ? 'off' : 'email'}
                        ref={this.firstField}
                        required
                    />
                </div>

                <div className="form-group">
                    <button
                        type="submit"
                        className="btn primary-button"
                        disabled={!this.state.email}
                    >
                        Send Email
                    </button>
                    <button
                        type="button"
                        className="btn secondary-button"
                        onClick={this.onSetEmailMode}
                        value=""
                    >
                        Cancel
                    </button>
                </div>

            </form>
        );
    }

    get body() {

        switch(this.state.emailMode) {
            case MODE_SIGN_IN:
                return this.signIn;
            case MODE_SIGN_UP:
                return this.signUp;
            case MODE_FORGOT_PASSWORD:
                return this.forgotPassword;
            default:
                return this.firebaseAuth;
        }
    }

    get remember() {

        if (this.props.loading) {
            return null;
        }

        return (
            <label className="option">
                <input
                    type="checkbox"
                    checked={this.props.remember}
                    onChange={this.onChangeRemember}
                /> Remember me
            </label>
        );
    }

    get reAuth() {

        if (this.props.loading) {
            return null;
        }

        return (
            <label className="option">
                <input
                    type="checkbox"
                    checked={this.props.reAuth}
                    onChange={this.onChangeReAuth}
                /> Re-authenticate
            </label>
        );
    }

    render() {

        return (
            <div className="user-login-form">
                <h3 className="form-container-header">
                    Sign In
                </h3>

                <div className="body">
                    {this.state.message ? (
                        <p className="message">
                            {this.state.message}
                        </p>
                    ) : null}
                    {this.body}
                    <div style={this.state.allowed ? { display: 'none' } : null} className="not-allowed" />
                </div>

                <div className="disclaimer" style={this.props.isLoggedIn ? { display: 'none' } : null}>
                    By continuing, you are agreeing to our <a rel="nofollow" target="_blank" href="https://commentbox.io/terms">Terms of Service</a> and <a rel="nofollow" target="_blank" href="https://commentbox.io/privacy">Privacy Policy</a>.
                </div>

                <div className="login-options">
                    {this.remember}
                    <Divider />
                    {this.reAuth}
                </div>

            </div>
        );
    }
}

export default withFormContainer(UserLoginForm);


// WEBPACK FOOTER //
// ./src/components/UserLoginForm.jsx